var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4016 7.99998C14.4016 11.5346 11.5362 14.4 8.00156 14.4C4.46694 14.4 1.60156 11.5346 1.60156 7.99998C1.60156 4.46535 4.46694 1.59998 8.00156 1.59998C11.5362 1.59998 14.4016 4.46535 14.4016 7.99998ZM8.80156 11.2C8.80156 11.6418 8.44339 12 8.00156 12C7.55974 12 7.20156 11.6418 7.20156 11.2C7.20156 10.7581 7.55974 10.4 8.00156 10.4C8.44339 10.4 8.80156 10.7581 8.80156 11.2ZM8.00156 3.99998C7.55974 3.99998 7.20156 4.35815 7.20156 4.79998V7.99998C7.20156 8.4418 7.55974 8.79998 8.00156 8.79998C8.44339 8.79998 8.80156 8.4418 8.80156 7.99998V4.79998C8.80156 4.35815 8.44339 3.99998 8.00156 3.99998Z",
    fill: "#C23934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/Exclamation_circle.c4d627608e3936497f4db70851703276.svg";
export { ForwardRef as ReactComponent };